/**
 * @module shop-public-constants
 * @ignore
 * __VERSION_HERE__
 */

export { CART_COUNT_UPDATED_EVENT_NAME } from '@nike/custom-event-names';
export var NIKE_SHOP_ROOT_ID = 'nike-shop-root';